import { Tag, Typography } from 'antd';
import { brandColors } from '@viq-admin/theme';
import { space } from '@viq-admin/ui';
import type { BatchConference } from './types';
import type { EventGroup } from './EventCard';

interface Props {
  conference: BatchConference;
  group: EventGroup;
}

/**
 * Event detail header. Ported from the portal's EventHeader: shows the name, the
 * date range (falling back to location when undated), and an "Active" tag when
 * the event is currently running.
 */
export function EventHeader({ conference, group }: Props) {
  const subtitle =
    conference.startDate && conference.endDate
      ? `${conference.startDate} to ${conference.endDate}`
      : conference.location ?? null;
  return (
    <div style={{ padding: '24px 16px 0' }}>
      <Typography.Title level={2} style={{ marginBottom: space.xs }}>
        {conference.name}
      </Typography.Title>
      <div style={{ display: 'flex', alignItems: 'center', gap: space.md }}>
        {subtitle && <Typography.Text type="secondary">{subtitle}</Typography.Text>}
        {group === 'active' && (
          <Tag
            color={brandColors.checkmarkGreen}
            style={{
              borderRadius: 12,
              padding: '2px 10px',
              color: brandColors.midnightNavy,
              border: 'none',
              fontWeight: 600,
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: brandColors.midnightNavy,
                marginRight: 6,
                verticalAlign: 'middle',
              }}
            />
            Active
          </Tag>
        )}
      </div>
    </div>
  );
}
